import { SVGProps } from 'react';

const SvgPeopleSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM73.7 237.3l-4.1 49.3c-.8 9.4 6.6 17.4 16 17.4H170.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3c-1.3-16.6-15.2-29.4-31.8-29.4h-44.8c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-31.1 219.6L319.6 336h128.8l-33.3-116.4c-2-6.9-8.2-11.6-15.4-11.6h-31.4c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-32v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z" />
  </svg>
);
export default SvgPeopleSimple;
